module.exports = __webpack_public_path__ + "static/media/twin.svg:Zone.914ef364.Identifier";